    import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import React, { useContext } from "react";
import BookingTimeline from "../BookingTimeline";
import { BrandContext } from "../../../contexts/BrandContext";
import { BookingConfigContext } from "../../../contexts/BookingConfigContext";


export default function BasicBookingsDialogue(props){
    const brandContext = useContext(BrandContext);
    const bookingConfig = useContext(BookingConfigContext);

    const {
        textContent:{
            closeButton='',
            bookingDetailDialogueHelperText='',
        },
        textContent
    } = brandContext;

    const {
        showDialogue,
        booking,
        setShowDialogue,
    } = props;
    
    const {
        travelModesMap={},
        destinationTypesMap={}
    } = bookingConfig;
    
    
    return (
        <Dialog
            fullWidth
            open={showDialogue}
            onClose={()=>{setShowDialogue(false)}}
        >
            <DialogTitle>
                {brandContext.textContent.bookingDetailDialogueTitle}
            </DialogTitle>
            <DialogContent>
                {bookingDetailDialogueHelperText && <DialogContentText>{bookingDetailDialogueHelperText}</DialogContentText>}
                <BookingTimeline
                    booking={booking}
                    textContent={textContent}
                    modeTypesMap={travelModesMap}
                    destinationTypesMap={destinationTypesMap}
                />
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={()=>{setShowDialogue(false)}}>
                   {closeButton}
                </Button>
            </DialogActions>
        </Dialog>
    );
}